<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadIvrs(1, null, true)">

      <template slot="actions">
        <vs-input type="number" :placeholder="$t('ivr_staff')" v-model="ivrFormData.number" class="configuration-inbound-ivr-number-input" />
        <vx-input-group>
          <vs-input :placeholder="$t('ivr.table.description')" v-model="ivrFormData.description" class="configuration-inbound-ivr-description-input" />
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button id="addConfigurationIvrsButton" color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="addIvr">{{ $t('ivr.button.add_ivr') }}</vs-button>
            </div>
          </template>
        </vx-input-group>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input type="number" :placeholder="$t('ivr_staff')" v-model="ivrSearchParams.number" class="w-full mb-3"/>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('ivr.table.description')" v-model="ivrSearchParams.description" class="w-full"/>
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadIvrs(1, null, true)" v-text="$t('search')"></vs-button>
      </template>

    </vx-card>

    <vx-card id="ivrDataContainer" :title="$t('ivr')" class="mb-8 vs-con-loading__container">

      <template slot="actions">
        <shared-configuration-tab-nav></shared-configuration-tab-nav>
      </template>

      <shared-user-configuration-inbound-ivr-list
        :ivrs="ivrs"
        @customClickEdit="edit"
        @customClickDelete="destroy"
        @customClickSave="save"
        @customClickCancel="cancel"
      ></shared-user-configuration-inbound-ivr-list>

      <template slot="footer">
        <paginate
          :total="ivrPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadIvrs"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>

    </vx-card>
  </div>
</template>

<script>
import SharedConfigurationTabNav from '@/views/Shared/Configuration/TabNav'
import Ivr from '@/models/Ivr'
import SharedUserConfigurationInboundIvrList from '@/views/Shared/Configuration/Inbound/Ivrs/List'
import Paginate from '@/mixins/paginate'

export default {
  name: 'User.Configuration.Inbound.Ivrs',
  mixins: [Paginate],
  components: {
    SharedConfigurationTabNav,
    SharedUserConfigurationInboundIvrList
  },
  data () {
    return {
      ivrsEdit: {},
      ivrs: {},
      ivrPages: 1,
      ivrFormData: {
        number: '',
        description: '',
        id: ''
      },
      ivrFormErrors: {},
      itemPerPage: null,
      ivrSearchParams: {
        number: typeof this.$route.query.number !== 'undefined' ? this.$route.query.number : '',
        description: typeof this.$route.query.description !== 'undefined' ? this.$route.query.description : ''
      }

    }
  },
  mounted () {
    this.loadIvrs(this.initialPage,  null, false, true)
  },
  methods: {
    async loadIvrs (page = 1, itemPerPage = null, backToPageOne = false, isOnLoad = false) {
      this.$vs.loading({container: '#ivrDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      if (!isOnLoad) {
        this.$router.replace({query: { ...this.ivrSearchParams, page, itemPerPage }})
      }
      const response = await Ivr.all({ ...this.ivrSearchParams, page, itemPerPage })
      this.ivrs = response.data.data.ivrs
      this.ivrPages = response.data.meta.pagination.last_page
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#ivrDataContainer > .con-vs-loading')
    },
    async addIvr (e) {
      e.preventDefault()
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addConfigurationIvrsButton', scale: 0.45})
      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)
          await Ivr.save(this.ivrFormData)
          this.$store.dispatch('setIsFormInProgress', false)
          this.loadIvrs(1, this.itemPerPage)
          this.ivrFormData = {
            number: '',
            description: '',
            id: ''
          }
          this.ivrFormErrors = {}
        }
      } catch (e) {
        this.ivrFormErrors = e.response.data.errors
      }
      this.$vs.loading.close('#addConfigurationIvrsButton > .con-vs-loading')
    },
    async edit (key) {
      this.ivrs[key].edit = true
      const editElem = this.ivrs[key]
      const editObj = {
        name: editElem.name,
        number: editElem.number,
        description: editElem.description
      }
      this.ivrsEdit[key] = editObj
    },
    async cancel (key) {
      this.ivrs[key].number = this.ivrsEdit[key].number
      this.ivrs[key].description = this.ivrsEdit[key].description
      this.ivrs[key].edit = false
      this.ivrs[key].ivrFormErrors = {}
      delete this.ivrsEdit[key]
    },
    async save (key, id) {
      this.$vs.loading({background: 'primary', color: '#fff', container: `#updateConfigurationIvrsButton${  id}`, scale: 0.45})
      try {
        await Ivr.update(this.ivrs[key])
        this.ivrs[key].edit = false
        this.ivrs[key].ivrFormErrors = {}
      } catch (e) {
        this.ivrs[key].ivrFormErrors = e.response.data.errors
      }
      this.$vs.loading.close(`#updateConfigurationIvrsButton${  id  } > .con-vs-loading`)
    },
    async destroy (key, id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        await Ivr.delete(id)
        this.loadIvrs(1, this.itemPerPage)
      }
    }
  }
}
</script>

<style lang="scss">
  #addConfigurationIvrsButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
